window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
window.BSS_B2B.addFilter("custom:bogo/shouldSkipQuantityCheck", () => true);

setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
            if (item.target.className === 'no-js-hidden' && item.target.localName === 'variant-radios') {
                document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
            }
            if (item.target.className === 'price__container') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }
            if (item.target.className === 'no-js-hidden' && item.target.localName === 'div') {
                BSS_B2B.observer.productSubject.notifyObserver('ProductMutate', 'ProductPriceMutate');
            }          
        }
    })
    observer.observe(document.body, {
        childList: true,
        subtree: true
    })
}, 300)